import { render, staticRenderFns } from "./DIASOrganizationSelection.vue?vue&type=template&id=47f3001e&"
import script from "./DIASOrganizationSelection.vue?vue&type=script&lang=js&"
export * from "./DIASOrganizationSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports